import React from 'react';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>The pages on the website ("the website") are published by
        JD Sports Fashion plc ("us", "we" or "JD Sports Fashion plc").
        <br />
        <br />
        We will not collect any information about individuals, except where it is specifically and
        knowingly provided by them.
        <br />
        <br />
        When you visit our website, our web server collects some basic information such as your
        internet service provider's domain name, which pages you accessed on our site, and when.
        <br />
        <br />
        We use this information only to analyse the use of our website to help guide improvements.
        We do not collect any personally identifiable information.<h2>Cookies</h2>When you visit our
        website, we use cookies, which are small pieces of information that allow us to maintain
        your connection to our website. This website may use cookies for detecting what kind of
        device you have in order to present content in the best way, for a language switch and/or
        for other purposes. You can learn more about our{' '}
        <a href="/cookies" title="Cookies Policy" className="link">
            cookies policy here
        </a>
        .<h2>Google Analytics</h2>This website uses Google Analytics, a web analytics service
        provided by Google, Inc. ("Google"). Google Analytics uses cookies (text files placed on
        your computer) to help the website operators analyse how users use the site. The information
        generated by the cookie about your use of the website (including your IP address) will be
        transmitted to and stored by Google on servers in the United States. Google will use this
        information for the purpose of evaluating your use of the website, compiling reports on
        website activity for website operators and providing other services relating to website
        activity and internet usage. Google may also transfer this information to third parties
        where required to do so by law, or where such third parties process the information on
        Google's behalf. Google will not associate your IP address with any other data held by
        Google. By using this website, you consent to the processing of data about you by Google in
        the manner and for the purposes set out above.<h2>How to refuse the use of cookies</h2>You
        may refuse the use of cookies by selecting the appropriate settings in your browser.
        However, if you do this you may lose some useful functionality such as personalisation and
        "keep me signed in" and "remember me" features.
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/privacy.jpg',
    body: Body,
};
